import React from 'react';
import AiChatBox from '@/components/AiChatBox';
import { useAttention } from './AttentionContext';

interface TrackedKaiChatProps {
  onSubmit: (question: string) => void;
  onResponse: (response: string) => void;
  context?: string;
}

/**
 * A wrapper for AiChatBox that tracks Kai interactions.
 * Completely invisible to users.
 */
export function TrackedKaiChat({ onSubmit, onResponse, context }: TrackedKaiChatProps) {
  const attention = useAttention();

  const handleSubmit = (question: string) => {
    // Track the Kai message
    if (attention) {
      attention.trackKaiMessage(question);
    }
    // Call original handler
    onSubmit(question);
  };

  return (
    <AiChatBox
      onSubmit={handleSubmit}
      onResponse={onResponse}
      context={context}
    />
  );
}

export default TrackedKaiChat;
